module.exports = __webpack_public_path__ + "static/service-section-mob-img-ed6561c67055621c95c6f5abab75feb6.png";